export default "__VITE_ASSET__DqurjzBA__"